import React from "react";
import tools from "../../assets/tools-bg-circle.svg";
// import toolsMobile from "../../assets/tools-mobile.svg";
import ScrollAnimation from "react-animate-on-scroll";
import Angular from "../../assets/icons/angular.svg";
import dotNet from "../../assets/icons/net.svg";
import ReactLogo from "../../assets/icons/react.svg";
import java from "../../assets/icons/java.svg";
import MachineLearning from "../../assets/icons/azure-ml.svg";
import GoogleCloud from "../../assets/icons/google-cloud.svg";
import Python from "../../assets/icons/python.svg";
import Aws from "../../assets/icons/aws.svg";

const EdgeTech = () => {
  return (
    <>
      <div className="container sm:container md:container lg:container w-full mx-auto pt-5 pb-8 md:pb-16">
        <div className="grid sm:grid-flow-row md:grid-flow-row  lg:grid-flow-col md:grid-cols-2 lg:grid-cols-2 sm:gap-2 sm:gap-6 md:gap-2 lg:gap-16 flex flex-col md:flex-row items-center">
          <div className="relative">
            <div className="lg:block hidden">
              <ScrollAnimation
                className="bg-white px-2 pt-1 pb-2 rounded-lg shadow-lg text-center leading-none"
                animateIn="fadeInLeft"
                style={{
                  width: "80px",
                  height: "auto",
                  position: "absolute",

                  top: "200px",
                  zIndex: "500",
                  left: "20%",
                }}
              >
                <img src={Angular} alt="" className="mx-auto" />
                <span className="text-xs">Angular</span>
              </ScrollAnimation>
              <ScrollAnimation
                className="bg-white px-2 pt-2 pb-2 rounded-lg shadow-lg text-center leading-none"
                animateIn="fadeInLeft"
                style={{
                  width: "76px",
                  height: "auto",
                  position: "absolute",

                  top: "150px",
                  zIndex: "500",
                  left: "45%",
                }}
              >
                <img src={dotNet} alt="" className="mx-auto" />
              </ScrollAnimation>
              <ScrollAnimation
                className="bg-white px-2 pt-1 pb-2 rounded-lg shadow-lg text-center leading-none"
                animateIn="fadeInLeft"
                style={{
                  width: "80px",
                  height: "auto",
                  position: "absolute",

                  top: "300px",
                  zIndex: "500",
                  left: "27%",
                }}
              >
                <img src={ReactLogo} alt="" className="mx-auto" />
                <span className="text-xs">React Js</span>
              </ScrollAnimation>
              <ScrollAnimation
                className="bg-white px-2 pt-1 pb-2 rounded-lg shadow-lg text-center leading-none"
                animateIn="fadeInLeft"
                style={{
                  width: "72px",
                  height: "auto",
                  position: "absolute",

                  top: "250px",
                  zIndex: "500",
                  left: "52%",
                }}
              >
                <img src={java} alt="" className="mx-auto" />
              </ScrollAnimation>
              <ScrollAnimation
                className="bg-white px-2 pt-3 pb-4 rounded-lg shadow-lg text-center leading-none"
                animateIn="fadeInLeft"
                style={{
                  width: "130px",
                  height: "auto",
                  position: "absolute",

                  top: "350px",
                  zIndex: "500",
                  left: "45%",
                }}
              >
                <img src={MachineLearning} alt="" className="mx-auto" />
                <span className="text-xs">Machine Learning</span>
              </ScrollAnimation>
              <ScrollAnimation
                className="bg-white px-2 pt-3 pb-3 rounded-lg shadow-lg text-center leading-none"
                animateIn="fadeInLeft"
                style={{
                  width: "120px",
                  height: "auto",
                  position: "absolute",

                  top: "130px",
                  zIndex: "500",
                  left: "63%",
                }}
              >
                <img src={GoogleCloud} alt="" className="mx-auto" />
                <span className="text-xs">Google Cloud</span>
              </ScrollAnimation>
              <ScrollAnimation
                className="bg-white px-2 pt-1 pb-3 rounded-lg shadow-lg text-center leading-none"
                animateIn="fadeInLeft"
                style={{
                  width: "80px",
                  height: "auto",
                  position: "absolute",
                  top: "320px",
                  zIndex: "500",
                  left: "70%",
                }}
              >
                <img src={Python} alt="" className="mx-auto" />
                <span className="text-xs">Python</span>
              </ScrollAnimation>
              <ScrollAnimation
                className="bg-white px-2 pt-1 pb-2 rounded-lg shadow-lg text-center leading-none"
                animateIn="fadeInLeft"
                style={{
                  width: "72px",
                  height: "auto",
                  position: "absolute",
                  top: "250px",
                  zIndex: "500",
                  right: "2%",
                }}
              >
                <img src={Aws} alt="" className="mx-auto" />
                <span className="text-xs">AWS AI</span>
              </ScrollAnimation>
              <img src={tools} alt="" className="relative z-50 mx-auto" />
            </div>
          </div>
          <div>
            <div className="md:pb-5 pb-0">
              <h2 className="brand-secondary-gradient text-3xl md:text-4xl font-semibold leading-normal font-avenirHeavy ">
                #cuttingedge
              </h2>
              {/* <div className="lg:hidden block">
              <img src={toolsMobile} alt="" className="mx-auto" />
            </div> */}
              <p className="text-base py-4 font-normal leading-loose text-Gray-600 font-opensans hidden md:block">
                Our vast expertise spectrum flows over a large variety of
                fields, delivering cutting edge solutions in different
                technologies such as{" "}
                <span className="font-semibold">
                  app platforms, cloud computing platform, machine learning,
                  data mining, data wrangling, back-end integration.
                </span>{" "}
                From data gathering to data analysis, to machine learning, to
                full-fledged applications, we can handle the whole life-cycle
                for your projects, visions, ideas.
              </p>
              <p className="text-base py-4 font-normal leading-loose text-Gray-600 font-opensans block md:hidden">
                Our vast expertise spectrum flows over a large variety of
                fields, delivering cutting edge solutions in different
                technologies such as{" "}
                <span className="font-semibold">
                  app platforms, cloud computing platform, machine learning,
                  data mining, data wrangling, back-end integration.
                </span>
              </p>
            </div>

            <div className="pt-5">
              <h2 className="brand-primary-gradient text-3xl  md:text-4xl font-semibold leading-normal font-avenirHeavy ">
                #innovative
              </h2>
              <p className="text-base py-3 font-normal leading-loose text-Gray-600 font-opensans  hidden md:block">
                We have the skills to breathe life into your idea with one
                purpose - ensure return on investment for your business. Our
                professionals bring deep experience from different industries,
                gained from hands-on expertise in various functions, sectors,
                and locations.
              </p>
              <p className="text-base py-3 font-normal leading-loose text-Gray-600 font-opensans block md:hidden">
                We have the skills to breathe life into your idea with one
                purpose - ensure return on investment for your business.
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EdgeTech;
